import React from 'react';
import Icon from '../../../components/AppIcon';
import { getCasePriorityLabel } from '../../../lib/casePriority';

const UrgencyBadge = ({ level }) => {
  const urgencyConfig = {
    normal: {
      label: 'Normal',
      icon: 'Info',
      className: 'bg-primary/10 text-primary border border-primary/20',
    },
    express: {
      label: 'Express',
      icon: 'AlertCircle',
      className: 'bg-error/10 text-error border border-error/20',
    },
    urgente: {
      label: 'Urgente',
      icon: 'Zap',
      className: 'bg-error/20 text-error border border-error/40 font-semibold',
    },
    low: {
      label: 'Basse',
      icon: 'Info',
      className: 'bg-primary/10 text-primary border border-primary/20'
    },
    medium: {
      label: 'Moyenne',
      icon: 'AlertTriangle',
      className: 'bg-warning/10 text-warning border border-warning/20'
    },
    high: {
      label: 'Haute',
      icon: 'AlertCircle',
      className: 'bg-error/10 text-error border border-error/20'
    },
    urgent: {
      label: 'Urgente',
      icon: 'Zap',
      className: 'bg-error/20 text-error border border-error/40 font-semibold'
    }
  };

  const base = urgencyConfig?.[level];
  const config = base ?? {
    label: getCasePriorityLabel(level) || '—',
    icon: 'AlertTriangle',
    className: urgencyConfig.medium.className,
  };

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${config?.className}`}>
      <Icon name={config?.icon} size={14} />
      {config?.label}
    </span>
  );
};

export default UrgencyBadge;